import { AxiosCore } from "../utils/AxiosCore"


export const getAllModelListProducts = async(token, offset, pageSize, keyword) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }
    return await AxiosCore.get("/costco/catalogs/v1/model-list", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true},
        params: queryParams
    })
}

export const getAllModelListProvidences = async(token, offset, pageSize, keyword) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }
    return await AxiosCore.get("/costco/catalogs/v1/province", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },
        params: queryParams
    })
}

export const saveProductModelList = async (token, body) => {
    return await AxiosCore.post("/costco/catalogs/v1/model-list", body, {
        headers: { Authorization: "Bearer " + token , "x-jwt": true},

    })
}

export const saveProvinceModelList = async (token, body) => {
    return await AxiosCore.post("/costco/catalogs/v1/province", body, {
        headers: { Authorization: "Bearer " + token , "x-jwt": true},

    })
}

export const editProductModelList = async (token, body, id) => {
    return await AxiosCore.put("/costco/catalogs/v1/model-list/"+id, body, {
        headers: { Authorization: "Bearer " + token , "x-jwt": true},

    })
}

export const editProvinceModelList = async (token, body, id) => {
    return await AxiosCore.put("/costco/catalogs/v1/province/"+id, body, {
        headers: { Authorization: "Bearer " + token , "x-jwt": true},

    })
}

export const deleteProductModelList = async (token, id) => {
    return await AxiosCore.delete("/costco/catalogs/v1/model-list/"+id, {
        headers: { Authorization: "Bearer " + token , "x-jwt": true},

    })
}

export const deleteProvinceModelList = async (token, id) => {
    return await AxiosCore.delete("/costco/catalogs/v1/province/"+id, {
        headers: { Authorization: "Bearer " + token , "x-jwt": true},

    })
}



export const downloadModelListReport = async (token) => {
    return await AxiosCore.get("/costco/catalogs/v1/file/download/model-list", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },
    })
}

export const downloadProvidenceReport = async (token) => {
    return await AxiosCore.get("/costco/catalogs/v1/file/download/province", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },
    })
}


export const uploadModelListFile = async (token, formData) => {
    return await AxiosCore.post("/costco/catalogs/v1/file/upload/model-list", formData, {
        headers: { 
            Authorization: "Bearer " + token,
            "x-jwt": true,
            "Content-Type" : "multipart/form-data" 
        },
    })
}

export const uploadProvidenceFile = async (token, formData) => {
    return await AxiosCore.post("/costco/catalogs/v1/file/upload/province", formData, {
        headers: { 
            Authorization: "Bearer " + token,
            "x-jwt": true,
            "Content-Type" : "multipart/form-data" 
        },
    })
}

export const downloadReport = async (token) => {
    return await AxiosCore.get("/costco/catalogs/v1/file/download/report", {
        headers: { 
            Authorization: "Bearer " + token,
            "x-jwt": true,
        },
    })
}

export const getAllGenericModelList = async (token, offset, pageSize, keyword) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }
    return await AxiosCore.get("/customers/catalogs/v1/generic-model-list", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },
        params: queryParams
    })
}

export const getGenericModelListByCustomer = async (token, offset, pageSize, keyword, customer) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }   
    return await AxiosCore.get("/customers/catalogs/v1/generic-model-list/" + customer, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },
        params: queryParams
    })
}

export const saveGenericModelList = async (token, body) => {
    return await AxiosCore.post("/customers/catalogs/v1/generic-model-list", body, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const editGenericModelList = async (token, body, id) => {
    return await AxiosCore.put("/customers/catalogs/v1/generic-model-list/" + id, body, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const deleteGenericModelList = async (token, id) => {
    return await AxiosCore.delete("/customers/catalogs/v1/generic-model-list/" + id, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const downloadGenericTemplate = async (token) => {
    return await AxiosCore.get("/customers/catalogs/v1/file/download/generic-model-list" , {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const uploadGenericModelListFile = async (token, formData) => {
    return await AxiosCore.post("/customers/catalogs/v1/file/upload/generic-model-list", formData, {
        headers: {
            Authorization: "Bearer " + token,
            "x-jwt": true,
            "Content-Type": "multipart/form-data"
        },
    })
}

/*begin cotscoProdIventory*/
export const getAllCotscoProdInventory = async (token, offset, pageSize, keyword) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }
    return await AxiosCore.get("/v1/costco/inventory/all", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true}
        ,params: queryParams
    })
}

export const saveCotscoProdInventory = async (token, body) => {
    return await AxiosCore.post("/v1/costco/inventory/prod", body, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const editCotscoProdInventory = async (token, body, id) => {
    return await AxiosCore.put("/v1/costco/inventory/prod/" + id, body, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const deleteCotscoProdInventory = async (token, id) => {
    return await AxiosCore.delete("/v1/costco/inventory/prod/" + id, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}
/*
export const uploadCotscoProdIventory = async (token, formData) => {
    return await AxiosCore.post("/customers/catalogs/v1/file/upload/generic-model-list", formData, {
        headers: {
            Authorization: "Bearer " + token,
            "x-jwt": true,
            "Content-Type": "multipart/form-data"
        },
    })
}*/
/*end  cotscoProdIventory*/

/*begin  GenericProdInventory*/

export const getAllGenericProdInventory = async (token, offset, pageSize, keyword) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }
    return await AxiosCore.get("/v1/customers/inventory/all", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true }
        ,params: queryParams
    })
}

export const getGenericProdInventoryByCustomer = async (token, offset, pageSize, keyword, customer) => {
    let queryParams = {}
    if (keyword) {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
            filter: keyword
        }
    } else {
        queryParams = {
            offset: offset,
            pageSize: pageSize,
        }
    }
    
    return await AxiosCore.get("/v1/customers/inventory/generic-prod/all/" + customer, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true }
        , params: queryParams
    })
}

export const saveGenericProdInventory = async (token, body) => {
    return await AxiosCore.post("/v1/customers/inventory/generic-prod", body, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const editGenericProdInventory = async (token, body, id) => {
    return await AxiosCore.put("/v1/customers/inventory/generic-prod/" + id, body, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}

export const deleteGenericProdInventory = async (token, id) => {
    return await AxiosCore.delete("/v1/customers/inventory/generic-prod/" + id, {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },

    })
}
/*
export const uploadGenericProdInventory = async (token, formData) => {
    return await AxiosCore.post("/customers/catalogs/v1/file/upload/generic-model-list", formData, {
        headers: {
            Authorization: "Bearer " + token,
            "x-jwt": true,
            "Content-Type": "multipart/form-data"
        },
    })
}*/

/*end  GenericProdInventory*/


export const getAllCustomer = async (token) => {
    return await AxiosCore.get("/customers/catalogs/v1/all/models?offset=0&pageSize=50", {
        headers: { Authorization: "Bearer " + token, "x-jwt": true },
    })
}
export const getGenericMaintenanceView = async (
    token,
    viewName,
    offset = 0,
    pageSize = 10,
    fields = '',
    filterCriteria = {},
    filterPersonalized = ''
) => {
    let queryParams = {
        offset: offset,
        pageSize: pageSize
    };
    if (fields) {
        queryParams.fields = fields;
    }
    let body = {};
    if (Object.keys(filterCriteria).length > 0) {
        body.filterCriteria = filterCriteria;
    }
    if (filterPersonalized) {
        body.filterPersonalized = filterPersonalized;
    }
    return await AxiosCore.post(
        //`http://localhost:8080/catalogs/generic-maintenance-view/${viewName}`,
        `customers/catalogs/v1/generic-maintenance-view/${viewName}`,
        body,
        {
            headers: {
                Authorization: 'Bearer ' + token,
                'x-jwt': true
            },
            params: queryParams
        }
    );
};

/**
 * Exporta y descarga el archivo de reporte de mantenimiento genérico.
 * @param {string} token - Token de autenticación
 * @param {object} body - Parámetros del reporte (viewName, fields, separator, filtros...)
 * @returns {Promise<{blob: Blob, extension: string}>}
 */
export const getGenericMaintenanceViewReport = async (token, body = {}) => {
    // Construir la URL relativa con los parámetros necesarios
    const { viewName, fields, separator } = body;
    const url = `customers/catalogs/v1/generic-maintenance-view/report/${viewName}?fields=${encodeURIComponent(fields)}&separator=${encodeURIComponent(separator)}`;
    //const url = `http://localhost:8080/catalogs/generic-maintenance-view/report/${viewName}/export?fields=${encodeURIComponent(fields)}&separator=${encodeURIComponent(separator)}`;
    // Preparar el cuerpo de la petición
    const requestBody = {};
    if (body.filterCriteria) requestBody.filterCriteria = body.filterCriteria;
    if (body.filterPersonalized) requestBody.filterPersonalized = body.filterPersonalized;

    // Usar AxiosCore para hacer la petición y obtener el blob
    const response = await AxiosCore.post(url, requestBody, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-jwt': 'true'
        },
        responseType: 'blob'
    });
    const blob = response.data;
    const contentType = response.headers['content-type'] || '';
    let extension = 'csv';
    if (contentType.includes('zip')) {
        extension = 'zip';
    } else if (contentType.includes('csv')) {
        extension = 'csv';
    }
    return { blob, extension };
};

export const getDataViewsConfig = async (token) => {
    const defaultConfig = {
        "views": [
            {
                "name": "HDK_LOG",
                "filters": true,
                "columns": [
                    { "id": "LOGID", "label": "Log ID", "type": "text", "width": "70px" },
                    { "id": "CUSTNAME", "label": "Customer Name", "type": "text", "width": "100px" },
                    { "id": "ORDERNO", "label": "Order Number", "type": "text", "width": "100px" },
                    { "id": "PONO", "label": "PO Number", "type": "text", "width": "100px" },
                    { "id": "RECEIVEDSTRING", "label": "Received String", "type": "text", "width": "400px" },
                    { "id": "RECEIVEDDATE", "label": "Received Date", "type": "date", "width": "150px" },
                    { "id": "RESPONSESTRING", "label": "Response String", "type": "text", "width": "400px" },
                    { "id": "RESPONSEDATE", "label": "Response Date", "type": "date", "width": "150px" }
                ],
                "data": []
            }
        ]
    };
    try {
        const response = await AxiosCore.get("/customers/catalogs/v1/config-parameters/name/dataViews", {
            headers: { Authorization: "Bearer " + token, "x-jwt": true }
        });
        if (response.status === 200 && response.data && response.data.content && response.data.content.value) {
            let value = response.data.content.value;
            if (typeof value === 'string') {
                value = value.trim();
                if (value.length === 0) return defaultConfig;
                try {
                    const parsed = JSON.parse(value);
                    if (parsed && parsed.views && Array.isArray(parsed.views) && parsed.views.length > 0) {
                        return parsed;
                    }
                } catch (e) {
                    // Si falla el parseo, usar default
                    return defaultConfig;
                }
            }
        }
    } catch (err) {
        // Si hay error, usar default
        return defaultConfig;
    }
    return defaultConfig;
};
// SAP Offline status services
export const getSapOfflineStatus = async (token) => {
    return await AxiosCore.get(
        "/customers/catalogs/v1/config-parameters/name/isSapOffline",
        {
            headers: {
                Authorization: "Bearer " + token,
                "x-jwt": true
            }
        }
    );
};

export const updateSapOfflineStatus = async (token, id, value) => {
    return await AxiosCore.put(
        `/customers/catalogs/v1/config-parameters/${id}`,
        {
            name: "isSapOffline",
            value: value ? "true" : "false"
        },
        {
            headers: {
                Authorization: "Bearer " + token,
                "x-jwt": true,
                "Content-Type": "application/json"
            }
        }
    );
};
// SAP Offline status services
